import { render, staticRenderFns } from "./stock-manage.vue?vue&type=template&id=bc70c5c6&scoped=true&"
import script from "./stock-manage.vue?vue&type=script&lang=js&"
export * from "./stock-manage.vue?vue&type=script&lang=js&"
import style0 from "./stock-manage.vue?vue&type=style&index=0&id=bc70c5c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc70c5c6",
  null
  
)

export default component.exports